import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, label }) => (
  <div className="flex items-center gap-4 mb-14" data-testid={`chapter-${num}`}>
    <span className="font-mono text-xs text-[#5E7E9B] tracking-[0.3em]">
      {num}
    </span>
    <span className="h-px w-10 bg-[#1F2D3D]/20" />
    <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#7A8492]">
      {label}
    </span>
  </div>
);
